import * as React from 'react';
import { Card, Form, Spinner } from "react-bootstrap";
import './ScheduleSpecialDebit.css';
import { ChangeBankingDetailsForm } from "./ChangeBankingDetailsForm";
import { ChangeBankingDetailsDisclosure } from "./ChangeBankingDetailsDisclosure";

export interface ScheduleSpecialDebitProps {
    form: {
        bankingDetails: {
            accountType: string;
            accountNumber: string;
            bankName: string;
            branchCode: string;
        };
        accountTypeList: {text: string, value: string}[];
        bankInfoList: {id?: string, name: string, avs?: boolean, avsRealtime?: boolean, debiCheck?: boolean, debiCheckRealtime?: boolean, branchCode?: string}[];
    },
    saving?: boolean;
    success?: boolean;
    premium: string;
    debitOrderDateList: any;
    emitHandleScheduleSpecialDebit;
    disableMainForm: boolean;
    bankInfoLoading;
}

interface State {
    specialDebitDay: string;
}

export class ScheduleSpecialDebit extends React.Component<ScheduleSpecialDebitProps,State> {
    constructor(props: ScheduleSpecialDebitProps) {
        super(props);
        
        this.state = {
            specialDebitDay: ''
        };
        
        this.handleChange = this.handleChange.bind(this);
        this.handleScheduleSpecialDebit = this.handleScheduleSpecialDebit.bind(this);
    }

    handleScheduleSpecialDebit(e: any) {
        if (!this.state.specialDebitDay || this.state.specialDebitDay == '') {
            return;
        }
        this.props.emitHandleScheduleSpecialDebit(this.state.specialDebitDay);
        
    }
    
    handleChange(e: any) {
        this.setState({
            ...this.state,
            [e.target.name]: e.target.value
        });
    }
    
    public render() {
        return (
            <Card className="col-12 p-1 schedule-special-debit">
                <Card.Header className="p-0 m-3">
                    <Card.Title className="change-debit-order__title row justify-content-between">
                        <h2>Schedule a special debit</h2>
                        <a>Pay with PayFast</a>
                    </Card.Title>
                    <hr />
                    <Card.Subtitle>
                        <p className="text-red">Total amount outstanding</p>
                        <p className="schedule-special-debit__amount">R { this.props.premium }</p>
                    </Card.Subtitle>
                </Card.Header>
                <Card.Body>
                    <div className="row mx-1">
                        <div className="change-banking-details">
                            <ChangeBankingDetailsForm bankInfoLoading={this.props.bankInfoLoading} disableForm={this.props.disableMainForm} emitHandleChange={this.handleChange} bankingDetails={this.props.form.bankingDetails} accountTypeList={this.props.form.accountTypeList} bankInfoList={this.props.form.bankInfoList}>
                                <div className="col-12 col-md-6">
                                    <Form.Group className="ssp-dropdown">
                                        <Form.Label className="font-weight-bold">Select special debit date</Form.Label>
                                        <Form.Control className="ssp-dropdown-icon" name="specialDebitDay" onChange={this.handleChange} value={this.state.specialDebitDay} as="select">
                                            <option selected></option>
                                            { this.props.debitOrderDateList?.map((option) => <option>{option}</option> )}
                                        </Form.Control>
                                    </Form.Group>
                                </div>
                            </ChangeBankingDetailsForm>
                            <hr className="my-1" />
                            <ChangeBankingDetailsDisclosure showSecure={false} textAlign={'text-left'} premium={this.props.premium}>
                                <p className="text-left">Please make sure that you have enough funds in your bank account so that the debit order can go through</p>
                            </ChangeBankingDetailsDisclosure>
                            <div className="col-12 text-center">
                                <button className="btn btn-solid-green" onClick={this.handleScheduleSpecialDebit}>
                                    { !this.props.saving && <>Schedule special debit</>
                                    ||
                                    <Spinner className="d-block mx-auto" animation="border" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </Spinner> }
                                </button>
                                    
                                    <div className="col-12 schedule-special-debit__secure mt-3 text-center row justify-content-center align-items-center">
                                    <div className="col-12 col-xl-auto">
                                        <img className="d-inline-block" src="./Images/LifeInsurance/icon-lock.png" />
                                    </div>
                                    <div className="col-12 col-xl-auto">
                                        <p className="d-inline-block text-left mb-0">
                                            <b>Secure connection</b>. Your info’s encrypted, which means it’s totally safe with us
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Card.Body>
            </Card>
        )
    }
}